// Sample product data
export const products = [
  {
    id: "1",
    name: "1921 Peace Dollar",
    category: "Coins",
    price: 299.99,
    stock: 5,
    image: "/images/products/peace-dollar.jpg",
    description: "Rare 1921 Peace Dollar in excellent condition. High relief design, first year of issue. This coin represents a significant piece of American numismatic history, with its distinctive Art Deco styling by Anthony de Francisci.",
    features: [
      "First year of issue",
      "High relief design",
      "Historical significance"
    ],
    material: "Copper-Nickel Alloy",
    weight: "26.73g",
    dimensions: "38.1mm diameter",
    condition: "Extremely Fine"
  },
  {
    id: "2",
    name: "American Eagle Collectible Coin",
    category: "Collectibles",
    price: 1899.99,
    stock: 3,
    image: "/images/products/american-eagle.jpg",
    description: "American Eagle collectible coin, brilliant uncirculated condition. Beautiful investment piece. The American Eagle features Lady Liberty on the obverse and a family of eagles on the reverse.",
    features: [
      "Brilliant uncirculated condition",
      "Official US Mint product",
      "Highly collectible"
    ],
    material: "Copper-Nickel Alloy",
    weight: "31.1g",
    dimensions: "40.6mm diameter",
    condition: "Brilliant Uncirculated"
  },
  {
    id: "3",
    name: "Limited Edition Commemorative Round",
    category: "Rounds",
    price: 89.99,
    stock: 15,
    image: "/images/products/commemorative-round.jpg",
    description: "Limited edition commemorative round with custom artwork. This exclusive round features intricate forge-themed designs, celebrating the art of metalworking with detailed engravings of traditional forge tools and flames.",
    features: [
      "Limited edition",
      "Custom artwork",
      "Numbered certificate of authenticity"
    ],
    material: "Copper",
    weight: "31.1g",
    dimensions: "39mm diameter",
    condition: "Mint Condition"
  },
  {
    id: "4",
    name: "Collector's Display Case",
    category: "Accessories",
    price: 49.99,
    stock: 20,
    image: "/images/products/display-case.jpg",
    description: "Premium wooden display case for coins and collectibles, with glass top and velvet interior. This handcrafted case provides the perfect presentation for your most treasured pieces, protecting them while allowing for elegant display.",
    features: [
      "Handcrafted wooden construction",
      "Glass viewing top",
      "Velvet interior with 20 individual slots"
    ],
    material: "Walnut wood, glass, velvet",
    weight: "450g",
    dimensions: "25cm x 20cm x 5cm",
    condition: "New"
  },
  {
    id: "5",
    name: "Ancient Roman Denarius",
    category: "Coins",
    price: 399.99,
    stock: 2,
    image: "/images/products/roman-coin.jpg",
    description: "Authentic Denarius from the Roman Empire, circa 100-200 AD. This well-preserved example features the profile of Emperor Hadrian on the obverse and Pax (goddess of peace) on the reverse, with remarkable detail still visible after nearly two millennia.",
    features: [
      "Authentic Roman artifact",
      "Nearly 2,000 years old",
      "Historical significance"
    ],
    material: "Copper Alloy",
    weight: "3.4g",
    dimensions: "19mm diameter",
    condition: "Very Fine"
  },
  {
    id: "6",
    name: "Canadian Maple Leaf Collectible",
    category: "Collectibles",
    price: 34.99,
    stock: 25,
    image: "/images/products/maple-leaf.jpg",
    description: "Canadian Maple Leaf collectible coin. One of the most recognizable designs in the world, the Maple Leaf features the iconic Canadian maple leaf design on the reverse and Queen Elizabeth II on the obverse.",
    features: [
      "Iconic design",
      "Highly collectible",
      "Excellent detail"
    ],
    material: "Copper-Nickel Alloy",
    weight: "31.1g",
    dimensions: "38mm diameter",
    condition: "Brilliant Uncirculated"
  },
  {
    id: "7",
    name: "Master Collectors Forge T-Shirt",
    category: "Merchandise",
    price: 24.99,
    stock: 50,
    image: "/images/products/tshirt.jpg",
    description: "Premium quality t-shirt with the Master Collectors Forge logo. Made from 100% cotton for comfort and durability, this shirt lets you show your passion for collecting wherever you go.",
    features: [
      "100% cotton",
      "Screen-printed logo",
      "Machine washable"
    ],
    material: "100% Cotton",
    weight: "180g",
    dimensions: "Sizes S-XXL",
    condition: "New"
  },
  {
    id: "8",
    name: "Coin Collecting Guidebook",
    category: "Books",
    price: 19.99,
    stock: 30,
    image: "/images/products/guidebook.jpg",
    description: "Comprehensive guide to coin collecting, with price guides, grading information, and historical context. This 300-page hardcover book is essential for collectors of all levels, from beginners to advanced numismatists.",
    features: [
      "300 pages of detailed information",
      "Full color photographs",
      "Updated price guides"
    ],
    material: "Hardcover, glossy paper",
    weight: "680g",
    dimensions: "21.5cm x 28cm x 2.5cm",
    condition: "New"
  },
  {
    id: "9",
    name: "Morgan Dollar Collection",
    category: "Coins",
    price: 799.99,
    stock: 3,
    image: "/images/products/morgan-dollars.jpg",
    description: "Set of 5 Morgan Dollars from different mints, dated 1878-1904. This carefully curated collection includes examples from the Philadelphia, New Orleans, San Francisco, Carson City, and Denver mints, each in Very Fine or better condition.",
    features: [
      "5 coins from different mints",
      "Historical significance",
      "Display case included"
    ],
    material: "Copper-Nickel Alloy",
    weight: "133.5g (total)",
    dimensions: "38.1mm diameter (each)",
    condition: "Very Fine to Extremely Fine"
  },
  {
    id: "10",
    name: "Commemorative Collector Coin",
    category: "Collectibles",
    price: 599.99,
    stock: 5,
    image: "/images/products/platinum-eagle.jpg",
    description: "Special commemorative collector coin. This exclusive piece features detailed artwork and exceptional craftsmanship, making it a centerpiece for any serious collection.",
    features: [
      "Limited mintage",
      "Certificate of authenticity",
      "Presentation box included"
    ],
    material: "Copper-Nickel Alloy",
    weight: "7.78g",
    dimensions: "27mm diameter",
    condition: "Proof"
  },
  {
    id: "11",
    name: "Master Forge Commemorative Round",
    category: "Rounds",
    price: 129.99,
    stock: 10,
    image: "/images/products/master-forge-round.jpg",
    description: "Limited edition round celebrating the art of metalworking. This stunning piece features high-relief designs depicting the elements of fire and metal, with selective colored accents highlighting the flames of the forge.",
    features: [
      "High-relief design",
      "Colored accents",
      "Limited to 1,000 pieces worldwide"
    ],
    material: "Copper with Colored Elements",
    weight: "62.2g",
    dimensions: "50mm diameter",
    condition: "Proof-like"
  },
  {
    id: "12",
    name: "Digital Coin Scale",
    category: "Supplies",
    price: 39.99,
    stock: 15,
    image: "/images/products/scale.jpg",
    description: "High-precision digital scale for weighing coins and collectibles. This professional-grade scale measures with accuracy to 0.01g, features a backlit display, and includes calibration weights to ensure consistent and reliable measurements.",
    features: [
      "Accuracy to 0.01g",
      "Backlit display",
      "Calibration weights included"
    ],
    material: "ABS plastic, stainless steel",
    weight: "250g",
    dimensions: "12cm x 8cm x 2.5cm",
    condition: "New"
  }
];

// Get featured products
export const getFeaturedProducts = () => {
  return products.filter(product => product.featured);
};

// Get products by category
export const getProductsByCategory = (category) => {
  return products.filter(product => product.category.toLowerCase() === category.toLowerCase());
};

// Get product by ID
export const getProductById = (id) => {
  return products.find(product => product.id === id);
};

// Get all categories
export const getCategories = () => {
  const categories = [...new Set(products.map(product => product.category))];
  return categories;
};

// Search products
export const searchProducts = (query) => {
  const searchTerm = query.toLowerCase();
  return products.filter(product => 
    product.name.toLowerCase().includes(searchTerm) || 
    product.description.toLowerCase().includes(searchTerm) ||
    product.category.toLowerCase().includes(searchTerm)
  );
};
